/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preset_Save_AbortedInputs */

const en_video_export_preset_save_aborted = /** @type {(inputs: Video_Export_Preset_Save_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save preset aborted.`)
};

const fr_video_export_preset_save_aborted = /** @type {(inputs: Video_Export_Preset_Save_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement du prereglage annule.`)
};

const de_video_export_preset_save_aborted = /** @type {(inputs: Video_Export_Preset_Save_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern der Voreinstellung abgebrochen.`)
};

const it_video_export_preset_save_aborted = /** @type {(inputs: Video_Export_Preset_Save_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio predefinito interrotto.`)
};

const ru_video_export_preset_save_aborted = /** @type {(inputs: Video_Export_Preset_Save_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранение настроек прервано.`)
};

const es_video_export_preset_save_aborted = /** @type {(inputs: Video_Export_Preset_Save_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se interrumpió el guardado del ajuste preestablecido.`)
};

const zh_cn2_video_export_preset_save_aborted = /** @type {(inputs: Video_Export_Preset_Save_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存预设已中止。`)
};

const ja_video_export_preset_save_aborted = /** @type {(inputs: Video_Export_Preset_Save_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットの保存が中止されました。`)
};

const hi_video_export_preset_save_aborted = /** @type {(inputs: Video_Export_Preset_Save_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट सेव करने की प्रक्रिया रद्द कर दी गई।`)
};

const pt_pt2_video_export_preset_save_aborted = /** @type {(inputs: Video_Export_Preset_Save_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvamento da predefinição cancelado.`)
};

/**
* | output |
* | --- |
* | "Save preset aborted." |
*
* @param {Video_Export_Preset_Save_AbortedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preset_save_aborted = /** @type {((inputs?: Video_Export_Preset_Save_AbortedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preset_Save_AbortedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preset_save_aborted(inputs)
	if (locale === "de") return de_video_export_preset_save_aborted(inputs)
	if (locale === "it") return it_video_export_preset_save_aborted(inputs)
	if (locale === "ru") return ru_video_export_preset_save_aborted(inputs)
	if (locale === "es") return es_video_export_preset_save_aborted(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preset_save_aborted(inputs)
	if (locale === "ja") return ja_video_export_preset_save_aborted(inputs)
	if (locale === "hi") return hi_video_export_preset_save_aborted(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preset_save_aborted(inputs)
	return en_video_export_preset_save_aborted(inputs)
});